import React from 'react';
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Typography,
  Link,
} from '@mui/material';

// NETWORK
import Loader from '../../../../common/Loader';

const PortedNumberList = ({
  country,
  carrier,
  portedNumbers,
  loading,
  navigate,
}) => {
  const showSingleCarrierPortedNumber = (portedNumber) => {
    navigate(
      `/admin/service-config/country/${country.country_code_id}/carrier/${carrier.carrier_id}/ported-number/${portedNumber.ported_numbers_id}`
    );
  };

  const handleAddNewCarrierPortedNumber = () => {
    navigate(
      `/admin/service-config/country/${country.country_code_id}/carrier/${carrier.carrier_id}/ported-number/0`
    );
  };

  const generateTable = () => {
    if (loading) return <Loader />;

    if (portedNumbers.length === 0) {
      return <Typography gutterBottom>No Carrier Ported Numbers</Typography>;
    }

    return (
      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table aria-label="ported number table">
          <TableHead>
            <TableRow>
              <TableCell>Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {portedNumbers.map((portedNumber) => (
              <TableRow
                id={`ported-number-${portedNumber.ported_numbers_id}`}
                key={portedNumber.ported_numbers_id}
              >
                <TableCell align="left">
                  <Link
                    tabIndex={0}
                    onClick={() => showSingleCarrierPortedNumber(portedNumber)}
                  >
                    {portedNumber.ported_number}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 2,
        }}
      >
        <Typography variant="h4">List of Carrier Ported Numbers</Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleAddNewCarrierPortedNumber}
        >
          Add New
        </Button>
      </Box>
      {generateTable()}
    </Box>
  );
};

export default PortedNumberList;
